import { render, staticRenderFns } from "./StudentGroups.vue?vue&type=template&id=b1cd9f22&"
import script from "./StudentGroups.vue?vue&type=script&lang=js&"
export * from "./StudentGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports